<template>
  <hooper :progress="true" :vertical="true">
    <slide style="background-color: red" class="flex-center">
      <div><h5>Question 1 of 10</h5><h2>Do you question your potential clients?</h2><ul><li class="question-box-answer"><label class="labl"><input type="radio" name="0" value="0"><div>Never</div></label></li><li class="question-box-answer"><label class="labl"><input type="radio" name="0" value="1"><div>Rarely</div></label></li><li class="question-box-answer"><label class="labl"><input type="radio" name="0" value="2"><div>Usually</div></label></li><li class="question-box-answer"><label class="labl"><input type="radio" name="0" value="3"><div>Always</div></label></li></ul><button data-v-4f3ba93a="" class="btn btn-primary ripple-parent"><!---->Next<!----></button></div>
    </slide>
    <slide style="background-color: green">
      slide 2
    </slide >
    <slide style="background-color: blue">
      slide 3
    </slide>
    <slide>
      slide 4
    </slide>
    <slide>
      slide 5
    </slide>
    <slide>
      slide 6
    </slide>

    <hooper-navigation slot="hooper-addons"></hooper-navigation>
  </hooper>
</template>

<script>
import {
  Hooper,
  Slide,
  Navigation as HooperNavigation,
  Pagination as HooperPagination,
  Progress as HooperProgress
  } from 'hooper';

export default {
  name: "hooper-test",
  components: {
    Hooper,
    Slide,
    HooperNavigation,
    HooperPagination,
    HooperProgress
  }
}
</script>

<style>


</style>